module.exports = __webpack_public_path__ + "img/gas.f4f24df7.svg";